module.exports = __webpack_public_path__ + "media/images/logo-login-f3eb1c19c31536ef510fcf2e1b5356f1.png";